let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("djzZI"), load("6Tuw7"), load("KSMZE")]).then(() => parcelRequire('jFrMf'));